export const percentageExperimentalBucket = (user, options) => {
  if (typeof user?.experimentBucket !== 'number') return false;
  const { percent } = options;

  return user.experimentBucket <= percent;
};
